import React from "react";
import "./TextButton.css";

const TextButton = React.forwardRef(function TextButton(
    {
        children,
        icon: Icon,
        iconRight: IconRight,
        variant = "default",
        size = "md",
        loading = false,
        fullWidth = false,
        className = "",
        disabled,
        type = "button",
        ...rest
    },
    ref
) {
    const iconSize = size === "sm" ? 12 : size === "lg" ? 16 : 14;
    return (
        <button
            ref={ref}
            type={type}
            className={[
                "text-btn",
                `text-btn--${variant}`,
                `text-btn--${size}`,
                fullWidth ? "text-btn--full" : "",
                "focus-ring",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            disabled={disabled || loading}
            aria-busy={loading || undefined}
            {...rest}
        >
            {Icon && !loading && <Icon size={iconSize} aria-hidden="true" />}
            {loading && <span className="text-btn__spinner" aria-hidden="true" />}
            <span className="text-btn__label">{children}</span>
            {IconRight && <IconRight size={iconSize} aria-hidden="true" />}
        </button>
    );
});

export default TextButton;
